export const ROLE_LABELS = {
  LOCAL_COUNCIL: "Consejo Local",
  DIRECTIVE_COUNCIL: "Consejo Directivo",
  TECHNICAL_COMMITTEE: "Comité Técnico"
}